import { axiosLoader } from "@fixit/utils";
import MyGiftCard from "../models/MyGiftCard";
import Vue from "vue";

export let GiftCardEventBus = new Vue();

async function loadModules() {
  if (process.client && window) {
    await axiosLoader();
  }
}

export default async function ($axios) {
  if (!$axios) {
    await loadModules();
  }
  const _axios = $axios ? $axios : window.axios ? window.axios : null;

  const GiftCardSvc = {
    async GetMyGiftCards(baseUrl, siteIds) {
      return await _axios
        .get(
          baseUrl +
            "/api/my-gift-cards" +
            `?${siteIds.map((n) => `siteIds=${n}`).join("&")}`
        )
        .then((res) => {
          if (res.data.responseCode === 200) {
            return res.data.result.map((r) => new MyGiftCard(r));
          }
        })
        .catch(function (e) {
          console.log(e);
          GiftCardEventBus.$emit("snackbar", {
            message: "Noe gikk galt under forsøket på å få gavekortene dine!",
            visible: true,
            duration: 3000,
            state: "error",
          });
          return [];
        });
    },
    async GetNumberOfActiveGiftCards(baseUrl, siteIds) {
      return await _axios
        .get(
          baseUrl +
            "/api/my-gift-cards/number-of-active-gift-cards" +
            `?${siteIds.map((n) => `siteIds=${n}`).join("&")}`
        )
        .then((res) => {
          if (res.data.responseCode == 200) {
            return res.data.result;
          }
        })
        .catch(function () {
          return 0;
        });
    },
    async GetGiftCardDetails(baseUrl, data) {
      return await _axios
        .get(baseUrl + "/api/my-gift-cards/" + data.barcode, {
          params: { usageArea: data.usageArea },
        })
        .then((res) => {
          if (res.data.responseCode == 200) {
            return new MyGiftCard(res.data.result);
          }
        })
        .catch(function () {
          GiftCardEventBus.$emit("snackbar", {
            message: "Noe gikk galt under forsøket på å få gavekortene dine!",
            visible: true,
            duration: 3000,
            state: "error",
          });
          return [];
        });
    },
  };
  return GiftCardSvc;
}
